import React from "react"
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa"
import { Link, graphql, useStaticQuery } from "gatsby"
import { IconContext } from "react-icons"
import GoLiveWithUsGroup from "./common/go-live-with-us-group"
import FeatureBar from "./common/feature-bar"
import { useEffect } from "react"
import { useState } from "react"
import clsx from "clsx"
import { SlArrowDown } from "react-icons/sl"

const mediaIcon = (type) => {
  switch (type) {
    case "instagram":
      return <FaInstagram />
    case "twitter":
      return <FaTwitter />
    case "linkedin":
      return <FaLinkedinIn />
    case "facebook":
      return <FaFacebookF />
    case "youtube":
      return <FaYoutube />
    default:
      return null
  }
}

export default function Footer({ slug, locale }) {
  const [isFrontPage, setIsFrontPage] = useState(false)
  const data = useStaticQuery(graphql`
    {
      allWordpressMenuLocation(
        filter: { location: { eq: "gatsby-footer-menu" } }
      ) {
        nodes {
          menuData {
            items {
              title
              url
              child_items {
                title
                url
              }
            }
          }
          language
        }
      }
      wp {
        themeGeneralSettings {
          themeSettings {
            logoWhite {
              localFile {
                url
              }
            }
          }
        }
      }
      allWordpressAcfOptions {
        nodes {
          language
          themeGeneralSettings {
            themeSettings {
              documentHeading
              documentExcerpt
              documentDescription
              logoWhite {
                mediaItemUrl
              }
              startTrading {
                target
                title
                url
              }
              privacyPolicy {
                target
                title
                url
              }
              goLiveWithUsGroup {
                cardList {
                  title
                  icon {
                    altText
                    mediaItemUrl
                  }
                  excerpt
                }
                excerpt
                heading
                links {
                  style
                  link {
                    target
                    title
                    url
                  }
                }
              }
              featureBar {
                title
                icon {
                  altText
                  mediaItemUrl
                }
              }
              socialTitle
              socialMedia {
                social
                socialLink
              }
            }
          }
        }
      }
    }
  `)

  const currentLanguage = {
    en_US: "en",
    id_ID: "id",
    vi_VN: "vi",
    zh_CN: "zh",
  }[locale]

  const readMoreButtonText = {
    en_US: "Read More",
    id_ID: "Baca Selengkapnya",
    vi_VN: "Xem thêm",
    zh_CN: "阅读更多",
  }[locale]

  const menu = data.allWordpressMenuLocation.nodes.find(
    (node) => node.language === currentLanguage
  )

  const wordpressAcfOptions = data.allWordpressAcfOptions.nodes.find(
    (node) => node.language === currentLanguage
  )

  const content = wordpressAcfOptions.themeGeneralSettings.themeSettings
  const logoWhite =
    data.wp.themeGeneralSettings.themeSettings.logoWhite.localFile.url
  const startTrading =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.startTrading
  const privacyPolicy =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.privacyPolicy
  const goLiveWithUsGroup =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.goLiveWithUsGroup
  const featureBar =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.featureBar
  const socialMedia =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.socialMedia
  const socialTitle =
    wordpressAcfOptions.themeGeneralSettings.themeSettings.socialTitle

  useEffect(() => {
    setIsFrontPage(slug === "home")
  }, [setIsFrontPage, slug])

  const [isOpen, setIsOpen] = useState(false)
  const onToggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <footer>
      <div className="container relative mx-auto">
        <div className="padding-x-10">
          {isFrontPage
            ? goLiveWithUsGroup && (
                <div className="-mb-20">
                  <GoLiveWithUsGroup data={goLiveWithUsGroup} />
                </div>
              )
            : featureBar && (
                <div className="-mb-10">
                  <FeatureBar data={featureBar} />
                </div>
              )}
        </div>
      </div>

      <div className="text-white bg-[#333333] pb-8 pt-32">
        <div className="container mx-auto">
          <div className="flex justify-between pb-8 padding-x-10">
            <Link to="/">
              <img
                src={logoWhite}
                alt="logo white"
                className="object-contain w-[138px] md:w-[150px] h-auto"
              />
            </Link>

            <a
              href={startTrading ? startTrading.url : "/"}
              target={startTrading ? startTrading.target : "_self"}
              rel="noreferrer noopener"
              className="btn fill"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 5.92 10.02"
                width="6"
              >
                <polygon
                  fill="currentColor"
                  points=".67 10.02 0 9.29 4.5 5.18 .39 .67 1.13 0 5.92 5.24 .67 10.02"
                />
              </svg>
              <span>{startTrading ? startTrading.title : "Start Trading"}</span>
            </a>
          </div>

          <div className="border-b border-zinc-600"></div>
        </div>

        <div className="container pt-4 mx-auto">
          <div className="padding-x-10">
            <div className="flex flex-col justify-between gap-y-10 lg:flex-row">
              <ul className="grid grid-cols-2 md:grid-cols-3 xl:flex flex-wrap gap-8 lg:gap-12 hover:[&_a]:text-primary [&_a]:transition-colors">
                {menu?.menuData?.items?.map((menuItem, i) => {
                  return (
                    <li
                      key={`footer-menu-${i}`}
                      className="relative h-full group max-w-[151px]"
                    >
                      <Link to={menuItem.url} className="text-sm font-bold">
                        <span className="whitespace-nowrap">
                          {menuItem.title}
                        </span>
                      </Link>

                      {menuItem.child_items?.length > 0 && (
                        <ul className="space-y-0.5 text-xs !leading-loose mt-2 lg:mt-4">
                          {menuItem.child_items.map((child, k) => {
                            return (
                              <li key={`footer-submenu-${k}`} className="">
                                <Link className="" to={child.url}>
                                  {child.title}
                                </Link>
                              </li>
                            )
                          })}
                        </ul>
                      )}
                    </li>
                  )
                })}
              </ul>

              {socialMedia && (
                <div>
                  <div className="text-xs lg:text-right">{socialTitle}</div>
                  <div className="flex justify-start mt-3 lg:justify-end gap-x-4 lg:mt-5">
                    <IconContext.Provider value={{ size: 22 }}>
                      {socialMedia.map((media, i) => {
                        return (
                          <div key={`media-${i}`} className="">
                            <a
                              href={media.socialLink}
                              target="_blank"
                              rel="noreferrer"
                              className="p-1.5 rounded-full bg-white/10 inline-block hover:bg-primary cursor-pointer hover:text-dark transition-all duration-300"
                            >
                              {mediaIcon(media.social)}
                            </a>
                          </div>
                        )
                      })}
                    </IconContext.Provider>
                  </div>
                </div>
              )}
            </div>

            <div className="pt-10 text-xs sm:flex max-sm:space-y-2 sm:divide-x divide-zinc-400 text-zinc-400">
              <div className="sm:pr-3">
                Copyright © {new Date().getFullYear()} Prospero
              </div>
              <div className="sm:px-3">
                <Link to={privacyPolicy ? privacyPolicy.url : "/"}>
                  <span>{privacyPolicy.title}</span>
                </Link>
              </div>
              <div className="sm:pl-3">
                Design by Qualia Creative
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-4xl py-10 mx-auto text-center">
        <h2 className="mb-4 text-base font-bold md:text-lg">
          {content.documentHeading}
        </h2>
        <div
          className={clsx(
            "transition-[grid-template-rows] duration-500 grid",
            isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
          )}
        >
          <div
            className="mb-4 overflow-hidden article-style description"
            dangerouslySetInnerHTML={{ __html: content.documentDescription }}
          ></div>
        </div>
        <div
          className="mb-4 article-style excerpt"
          dangerouslySetInnerHTML={{ __html: content.documentExcerpt }}
        ></div>
        <button
          type="button"
          className="inline-flex items-center space-x-2 font-bold"
          onClick={onToggle}
        >
          <IconContext.Provider value={{ size: 16 }}>
            <SlArrowDown className={isOpen ? "rotate-180" : ""} />
          </IconContext.Provider>
          <span>{readMoreButtonText}</span>
        </button>
      </div>
    </footer>
  )
}
